export interface MetaEntry {
  title: string;
  description: string;
  canonicalPath: string;
  breadcrumbName: string;
  ogImage?: string;
  robotsDirective?: string;
}

export const defaultMeta: MetaEntry = {
  title: "Craft Civil Contractors | Auckland Civil Services",
  description:
    "Professional civil contracting services in Auckland including drainage, earthworks, plumbing and concrete work.",
  canonicalPath: "/",
  breadcrumbName: "Home",
  ogImage: "/media/asset-01.png",
  robotsDirective: "index, follow",
};

export const metaByPath: Record<string, MetaEntry> = {
  "/": {
    title: "Craft Civil Contractors | Auckland Civil Contracting Services",
    description:
      "Auckland's trusted civil contractors for drainage, earthworks, concrete driveways, plumbing & drainlaying. Fully licensed & insured. Call 021 029 84443.",
    canonicalPath: "/",
    breadcrumbName: "Home",
    ogImage: "/media/asset-01.png",
    robotsDirective: "index, follow",
  },
  "/services": {
    title: "Civil Contracting Services Auckland | Craft Civil Contractors",
    description:
      "Explore our Auckland civil contracting services: public & private drainage, licensed drainlaying, drain unblocking, earthworks, plumbing & concrete work.",
    canonicalPath: "/services",
    breadcrumbName: "Services",
    ogImage: "/media/asset-01.png",
    robotsDirective: "index, follow",
  },
  "/services/drainage": {
    title: "Public & Private Drainage Contractors Auckland | Craft Civil",
    description:
      "Certified public and private drainage contractors in Auckland. Stormwater networks, sewer connections, soak holes & Council GeoMaps verified installations.",
    canonicalPath: "/services/drainage",
    breadcrumbName: "Drainage",
    ogImage: "/media/asset-01.png",
    robotsDirective: "index, follow",
  },
  "/services/private-drainage": {
    title: "Private Drain Installation Auckland | Residential Drainage",
    description:
      "Certified private drain installation & repairs in Auckland. Residential stormwater systems, soak holes, GAP20 subgrade bedding & boundary connections.",
    canonicalPath: "/services/private-drainage",
    breadcrumbName: "Private Drainage",
    ogImage: "/media/asset-01.png",
    robotsDirective: "index, follow",
  },
  "/services/public-drainage": {
    title: "Watercare Public Drainage Connections Auckland | Works Over Approvals",
    description:
      "Certified Watercare public drainage contractors in Auckland. Experts in public sewer connections, Works Over Approvals, precast manholes & stormwater main extensions. Call 021 029 84443.",
    canonicalPath: "/services/public-drainage",
    breadcrumbName: "Public Drainage",
    ogImage: "/media/asset-01.png",
    robotsDirective: "index, follow",
  },
  "/services/drainlaying": {
    title: "Licensed Drainlayer Auckland | Certified Pipework & PS3 | Craft Civil",
    description:
      "PGDB certified licensed drainlayer in Auckland. Complete sewer & stormwater pipework, building consent drainage & Producer Statement PS3 sign-offs. Call 021 029 84443.",
    canonicalPath: "/services/drainlaying",
    breadcrumbName: "Licensed Drainlaying",
    ogImage: "/media/asset-01.png",
    robotsDirective: "index, follow",
  },
  "/services/drain-unblocking": {
    title: "24/7 Emergency Drain Unblocking Auckland | CCTV & Jetting",
    description:
      "24/7 emergency drain unblocking in Auckland. Fast 15-20 min clearance of blocked sewers & stormwater drains using 4,000 PSI hydro-jetting & CCTV camera locator.",
    canonicalPath: "/services/drain-unblocking",
    breadcrumbName: "Drain Unblocking",
    ogImage: "/media/asset-01.png",
    robotsDirective: "index, follow",
  },
  "/services/rainwater-tank-install": {
    title: "Stormwater Detention Tank Installation Auckland | SMAF 1 & 2 Tanks",
    description:
      "Auckland Unitary Plan SMAF 1 & 2 stormwater detention tank installation. Certified base excavation, concrete pads, orifice restrictor plates & council sign-offs. Call 021 029 84443.",
    canonicalPath: "/services/rainwater-tank-install",
    breadcrumbName: "Rainwater & Detention Tanks",
    ogImage: "/media/asset-01.png",
    robotsDirective: "index, follow",
  },
  "/services/wastewater-systems": {
    title: "Wastewater & Sewer System Installation Auckland | Craft Civil",
    description:
      "Wastewater & sewer system installation in Auckland. Graded sewer pipework, inspection chambers, sewer upgrades & compliant boundary connections.",
    canonicalPath: "/services/wastewater-systems",
    breadcrumbName: "Wastewater & Sewer Systems",
    ogImage: "/media/asset-01.png",
    robotsDirective: "index, follow",
  },
  "/services/earthworks-demolition": {
    title: "Subdivision Earthworks & Demolition Auckland | Site Prep",
    description:
      "Professional subdivision earthworks, site excavation, house pad grading & controlled demolition in Auckland. GD05 erosion & sediment control compliant.",
    canonicalPath: "/services/earthworks-demolition",
    breadcrumbName: "Earthworks & Demolition",
    ogImage: "/media/asset-01.png",
    robotsDirective: "index, follow",
  },
  "/services/concrete-civil": {
    title: "Auckland Transport Vehicle Crossing Contractors | AT TDM VX0102",
    description:
      "Approved Auckland Transport vehicle crossing contractors. Full management of AT TDM VX0102 crossings, Corridor Access Requests (CAR), drop kerbs & concrete driveways. Call 021 029 84443.",
    canonicalPath: "/services/concrete-civil",
    breadcrumbName: "Concrete & Vehicle Crossings",
    ogImage: "/media/asset-01.png",
    robotsDirective: "index, follow",
  },
  "/services/plumbing": {
    title: "Commercial Plumber Auckland | Civil Infrastructure Plumbing",
    description:
      "Registered commercial & civil plumbing contractors in Auckland. Water main connections, backflow prevention testing & industrial pipework.",
    canonicalPath: "/services/plumbing",
    breadcrumbName: "Plumbing",
    ogImage: "/media/asset-01.png",
    robotsDirective: "index, follow",
  },
  "/service-areas/central-isthmus/hillsborough": {
    title: "Drainlayer Hillsborough Auckland | Craft Civil Contractors",
    description:
      "PGDB licensed drainlayers based at 110 Carlton St, Hillsborough. Fast 15-min emergency drain unblocking, CCTV camera inspection & council drainage repairs. Call 021 029 84443.",
    canonicalPath: "/service-areas/central-isthmus/hillsborough",
    breadcrumbName: "Hillsborough",
    ogImage: "/media/asset-01.png",
    robotsDirective: "index, follow",
  },
  "/service-areas/central-isthmus/onehunga": {
    title: "Drainlayer Onehunga | Soakhole Installation & Drainage Repairs",
    description:
      "Licensed drainlayers in Onehunga. Specialists in volcanic basalt rock soakhole drilling, heritage villa drainage renewals & industrial commercial pipework. Call 021 029 84443.",
    canonicalPath: "/service-areas/central-isthmus/onehunga",
    breadcrumbName: "Onehunga",
    ogImage: "/media/asset-01.png",
    robotsDirective: "index, follow",
  },
  "/service-areas/central-isthmus/mt-roskill": {
    title: "Drainlayer Mt Roskill | Infill Housing & Terrace Drainage",
    description:
      "PGDB certified drainlayers in Mt Roskill. Specialists in multi-unit terrace housing drainage, public sewer upgrades & council PS3 sign-offs. Call 021 029 84443.",
    canonicalPath: "/service-areas/central-isthmus/mt-roskill",
    breadcrumbName: "Mount Roskill",
    ogImage: "/media/asset-01.png",
    robotsDirective: "index, follow",
  },
  "/service-areas/central-isthmus/mount-roskill": {
    title: "Drainlayer Mt Roskill | Infill Housing & Terrace Drainage",
    description:
      "PGDB certified drainlayers in Mt Roskill. Specialists in multi-unit terrace housing drainage, public sewer upgrades & council PS3 sign-offs. Call 021 029 84443.",
    canonicalPath: "/service-areas/central-isthmus/mt-roskill",
    breadcrumbName: "Mount Roskill",
    ogImage: "/media/asset-01.png",
    robotsDirective: "index, follow",
  },
  "/service-areas/south-auckland/papakura-drury": {
    title: "Subdivision Drainage Papakura & Drury | Veolia Connections",
    description:
      "Civil drainage contractors for Papakura, Drury & Takanini subdivisions. Certified for Veolia network connections, S224(c) public drainage & bulk earthworks. Call 021 029 84443.",
    canonicalPath: "/service-areas/south-auckland/papakura-drury",
    breadcrumbName: "Papakura & Drury",
    ogImage: "/media/asset-01.png",
    robotsDirective: "index, follow",
  },
  "/service-areas/south-auckland": {
    title: "Subdivision Drainage Papakura & Drury | Veolia Connections",
    description:
      "Civil drainage contractors for Papakura, Drury & Takanini subdivisions. Certified for Veolia network connections, S224(c) public drainage & bulk earthworks. Call 021 029 84443.",
    canonicalPath: "/service-areas/south-auckland/papakura-drury",
    breadcrumbName: "South Auckland",
    ogImage: "/media/asset-01.png",
    robotsDirective: "index, follow",
  },
  "/service-areas/west-auckland/new-lynn-henderson": {
    title: "Drainage Contractors West Auckland | New Lynn & Henderson",
    description:
      "West Auckland drainage specialists. Engineered subsoil French drains for heavy clay soil, SMAF detention tanks & residential drainlaying in New Lynn & Henderson. Call 021 029 84443.",
    canonicalPath: "/service-areas/west-auckland/new-lynn-henderson",
    breadcrumbName: "West Auckland",
    ogImage: "/media/asset-01.png",
    robotsDirective: "index, follow",
  },
  "/service-areas/west-auckland": {
    title: "Drainage Contractors West Auckland | New Lynn & Henderson",
    description:
      "West Auckland drainage specialists. Engineered subsoil French drains for heavy clay soil, SMAF detention tanks & residential drainlaying in New Lynn & Henderson. Call 021 029 84443.",
    canonicalPath: "/service-areas/west-auckland/new-lynn-henderson",
    breadcrumbName: "West Auckland",
    ogImage: "/media/asset-01.png",
    robotsDirective: "index, follow",
  },
  "/about": {
    title: "About Us | Craft Civil Contractors Auckland",
    description:
      "Learn about Craft Civil Contractors: 15+ years of practical civil experience, safety standards, PGDB compliance & coverage across Greater Auckland.",
    canonicalPath: "/about",
    breadcrumbName: "About Us",
    ogImage: "/media/asset-01.png",
    robotsDirective: "index, follow",
  },
  "/testimonials": {
    title: "Client Testimonials | Craft Civil Contractors",
    description:
      "Read genuine client feedback & project outcomes from residential, commercial & civil contracting work across Auckland by Craft Civil Contractors.",
    canonicalPath: "/testimonials",
    breadcrumbName: "Testimonials",
    ogImage: "/media/asset-01.png",
    robotsDirective: "index, follow",
  },
  "/contact": {
    title: "Contact Us | Craft Civil Contractors Auckland",
    description:
      "Get in touch with Craft Civil Contractors for civil & drainage quotes in Auckland. Call 021 029 84443, email admin@craftcivil.co.nz or submit an enquiry.",
    canonicalPath: "/contact",
    breadcrumbName: "Contact",
    ogImage: "/media/asset-01.png",
    robotsDirective: "index, follow",
  },
  "/privacy": {
    title: "Privacy Policy | Craft Civil Contractors",
    description:
      "Read the official Craft Civil Contractors privacy policy to understand how personal information & project enquiries are collected and protected.",
    canonicalPath: "/privacy",
    breadcrumbName: "Privacy Policy",
    ogImage: "/media/asset-01.png",
    robotsDirective: "index, follow",
  },
  "/terms": {
    title: "Terms of Service | Craft Civil Contractors",
    description:
      "Review the official terms of service governing the use of Craft Civil Contractors website, project quotes & contracting services.",
    canonicalPath: "/terms",
    breadcrumbName: "Terms of Service",
    ogImage: "/media/asset-01.png",
    robotsDirective: "index, follow",
  },
};
